document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.six-reviews-slider').forEach((slider, sliderIndex) => {
    const track = slider.querySelector('.li__reviews');
    const slides = Array.from(track?.querySelectorAll('.li__review') || []);
    if (slides.length < 2) return;
    track.id = `six-review-track-${sliderIndex}`;
    track.tabIndex = 0;
    track.setAttribute('role', 'region');
    track.setAttribute('aria-roledescription', 'carousel');
    track.setAttribute('aria-label', 'Customer stories');
    slides.forEach((slide, i) => {
      slide.setAttribute('aria-roledescription', 'slide');
      slide.setAttribute('aria-label', `${i + 1} of ${slides.length}`);
    });
    const controls = document.createElement('div');
    controls.className = 'six-review-controls';
    controls.innerHTML = `<div class="six-review-dots">${slides.map((_, i) => `<button class="six-review-dot" type="button" aria-label="Show review ${i + 1} of ${slides.length}" aria-controls="${track.id}" aria-current="${i === 0}"></button>`).join('')}</div><div class="six-review-arrows"><output class="six-review-position" aria-live="polite" aria-atomic="true">1 / ${slides.length}</output><button class="six-review-arrow" type="button" aria-label="Previous customer story" aria-controls="${track.id}" disabled><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 6-6 6 6 6M8 12h12"/></svg></button><button class="six-review-arrow" type="button" aria-label="Next customer story" aria-controls="${track.id}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 6 6 6-6 6M16 12H4"/></svg></button></div>`;
    slider.append(controls);
    const dotList = controls.querySelector('.six-review-dots');
    let dots = [];
    const [previous, next] = controls.querySelectorAll('.six-review-arrow');
    const position = controls.querySelector('output');
    let current = 0;
    let stops = [0];
    const goTo = (index, behavior = 'smooth') => {
      index = Math.max(0, Math.min(stops.length - 1, index));
      track.scrollTo({left: stops[index],
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : behavior});
    };
    const update = () => {
      current = stops.reduce((best, left, i) => Math.abs(left - track.scrollLeft) < Math.abs(stops[best] - track.scrollLeft) ? i : best, 0);
      previous.disabled = current === 0;
      next.disabled = current === stops.length - 1;
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
      const text = `${current + 1} / ${stops.length}`;
      if (position.textContent !== text) position.textContent = text;
    };
    const refresh = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      // Several cards may fit at once. Merge end positions that clamp to
      // the same scroll offset so each navigation dot has a real destination.
      stops = slides.reduce((positions, slide) => {
        const left = Math.min(maxScroll, slide.offsetLeft - slides[0].offsetLeft);
        if (!positions.length || left - positions[positions.length - 1] > 2) positions.push(left);
        return positions;
      }, []);
      current = Math.min(current, stops.length - 1);
      dots = stops.map((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'six-review-dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', `Show customer stories page ${i + 1} of ${stops.length}`);
        dot.setAttribute('aria-controls', track.id);
        dot.addEventListener('click', () => goTo(i));
        return dot;
      });
      dotList.replaceChildren(...dots);
      controls.hidden = stops.length < 2;
      goTo(current, 'auto');
      update();
    };
    previous.addEventListener('click', () => goTo(current - 1));
    next.addEventListener('click', () => goTo(current + 1));
    track.addEventListener('scroll', update, {passive: true});
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      goTo(event.key === 'Home' ? 0 : event.key === 'End' ? stops.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    new ResizeObserver(refresh).observe(track);
    refresh();
  });
  document.querySelectorAll('.jm-review-content__expand-button').forEach(button => {
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      const body = button.closest('.jm-review-content').querySelector('.jm-review-content__body');
      body.style.webkitLineClamp = expanded ? 'unset' : '5';
      button.querySelector('p').textContent = expanded ? 'Less' : 'More';
    });
  });
  const lightbox = document.createElement('dialog');
  lightbox.className = 'six-image-dialog';
  lightbox.innerHTML = '<button type="button" aria-label="Close image">×</button><img alt="Review photo">';
  document.body.append(lightbox);
  lightbox.querySelector('button').addEventListener('click', () => lightbox.close());
  lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
  document.querySelectorAll('.jm-media-grid__item, [aria-label="View review image"]').forEach(button => {
    const show = () => {
      const image = button.querySelector('img');
      if (!image) return;
      lightbox.querySelector('img').src = image.src;
      lightbox.showModal();
    };
    button.addEventListener('click', show);
    if (button.tagName !== 'BUTTON') button.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); show(); }
    });
  });
  document.querySelectorAll('.jm-media-grid__arrow').forEach(button => {
    button.addEventListener('click', () => {
      const list = button.parentElement.querySelector('[role="group"]') || button.parentElement.querySelector('.jm-media-grid__list');
      list?.scrollBy({left: (button.classList.contains('jm-media-grid__arrow--next') ? 1 : -1) * 300, behavior:'smooth'});
    });
  });
  document.querySelectorAll('.faq__item').forEach(item => {
    const summary = item.querySelector('.faq__q');
    const wrap = item.querySelector('.faq__a-wrap');
    if (!summary || !wrap) return;
    summary.addEventListener('click', event => {
      event.preventDefault();
      if (item.classList.contains('is-open')) {
        item.classList.remove('is-open');
      } else {
        item.open = true;
        requestAnimationFrame(() => requestAnimationFrame(() => item.classList.add('is-open')));
      }
    });
    wrap.addEventListener('transitionend', event => {
      if (event.propertyName === 'grid-template-rows' && !item.classList.contains('is-open')) item.open = false;
    });
  });
  document.querySelectorAll('.bb-item__header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.bb-item');
      const root = item.closest('[data-multiple]');
      const open = !item.classList.contains('is-open');
      if (open && root?.dataset.multiple !== 'true') {
        root?.querySelectorAll('.bb-item').forEach(other => {
          other.classList.remove('is-open');
          other.querySelector('.bb-item__header')?.setAttribute('aria-expanded', 'false');
        });
      }
      item.classList.toggle('is-open', open);
      header.setAttribute('aria-expanded', String(open));
    });
  });
  document.querySelectorAll('[data-pdp-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const root = thumb.closest('.custom-pdp');
      root.querySelector('[data-pdp-main]').src = thumb.dataset.pdpThumb;
      root.querySelectorAll('[data-pdp-thumb]').forEach(el => el.classList.toggle('is-active', el === thumb));
    });
  });
  // The shared bp-product-form owns Shopify IDs, prices, selling plans,
  // gifts and the cart. Keep the same static CTA label as the PDP.
  document.querySelectorAll('[data-six-preview-form]').forEach(form => {
    form.addEventListener('submit', event => event.preventDefault());
  });
  document.querySelectorAll('[data-bb-scroll-to]').forEach(button => {
    button.addEventListener('click', () => document.querySelector('.custom-pdp')?.scrollIntoView({behavior: 'smooth'}));
  });
});
